import useCustomHook from '@/hooks/useCustomHook';
import filterThemes from '@/modules/search/filterThemes';
import filterThemesWithOtherTags from '@/modules/search/filterThemesWithOtherTags';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { NavigationContext } from '@/shared/NavigationContext/NavigationContext';
import { ThemesContext } from '@/shared/ThemesContext/ThemesContext';
import { useContext, useEffect } from 'react';

export default function usePublicThemes({ themes }) {
  const globalContext = useContext(GlobalContext);
  const navigationContext = useContext(NavigationContext);
  const themesContext = useContext(ThemesContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      themes: themes.filter(
        (theme) => theme.language == globalContext.state.selectedLanguage
      ),
      themesNotInThisTag: [],
    },
    actions: {
      removeSelectedTag() {
        navigationContext.actions.setSelectedTagId(null);
      },
    },
  });

  useEffect(() => {
    if (themesContext.state.loaded) {
      const searchText = navigationContext.state.pagesData.themes?.searchText;
      const selectedTagId = navigationContext.state.selectedTagId;
      const activityType =
        navigationContext.state.pagesData.themes?.activityType;

      const filteredThemes = filterThemes({
        searchText,
        themes: themesContext.state.themes,
        language: globalContext.state.selectedLanguage,
        tagIds: [selectedTagId],
        activityType,
      });

      const themesNotInThisTag = filterThemesWithOtherTags({
        searchText,
        themes: themesContext.state.themes,
        filteredThemes,
        language: globalContext.state.selectedLanguage,
        selectedTagId,
        activityType,
      });

      actions.setState({
        themes: filteredThemes,
        themesNotInThisTag,
      });
    }
  }, [
    themesContext.state.loaded,
    themesContext.state.themes,
    navigationContext.state.pagesData.themes?.searchText,
    globalContext.state.selectedLanguage,
    navigationContext.state.selectedTagId,
    navigationContext.state.pagesData.themes?.activityType,
  ]);

  return { state, actions };
}
